export default __webpack_public_path__ + "static/media/Nitroxgallery_62.eb10cbce.JPG";